/**
 * Candidate Menu - Sidebar Navigation
 *
 * Handles the dropdown functionality for updating candidate availability status
 * in the sidebar menu. Allows candidates to set their job search status.
 *
 * @package CodersLink_CVCreator
 * @version 1.0.0
 */

$(document).ready(function () {
    var base_url = $('#base_url').val();

    // ============================================
    // CANDIDATE AVAILABILITY DROPDOWN
    // ============================================

    if ($('.menu-talento-v2').length) {

        /**
         * Toggle dropdown options visibility
         */
        $('.menu-talento-v2 .candidate_availability_dropdown .dropdown').on('click', function(e) {
            e.preventDefault();

            // Toggle options visibility
            $('.menu-talento-v2 .candidate_availability_dropdown .options').toggle();

            return false;
        });

        /**
         * Click handler: Actively Searching
         */
        $('.menu-talento-v2 .candidate_availability_dropdown .options .actively_searching').on('click', function(e) {
            e.preventDefault();

            updateCandidateAvailability('Actively searching');

            return false;
        });

        /**
         * Click handler: Open to Hearing
         */
        $('.menu-talento-v2 .candidate_availability_dropdown .options .open_to_hearing').on('click', function(e) {
            e.preventDefault();

            updateCandidateAvailability('Open to hearing');

            return false;
        });

        /**
         * Click handler: Not Interested
         */
        $('.menu-talento-v2 .candidate_availability_dropdown .options .not_interested').on('click', function(e) {
            e.preventDefault();

            updateCandidateAvailability('Not interested');

            return false;
        });

        /**
         * Update Candidate Availability Status
         *
         * Sends AJAX request to update the candidate's availability status
         * and updates the UI accordingly.
         *
         * API Endpoint: talentCandidateAvailability
         *
         * @param {string} status - One of: 'Actively searching', 'Open to hearing', 'Not interested'
         */
        function updateCandidateAvailability(status) {
            // Get candidate ID from hidden input
            var id = $(".menu-talento-v2 .candidate_availability_dropdown #candidate_id_availability").val();
            var availability = status;

            // Validate data
            if (id && availability) {
                // Hide options dropdown
                $('.menu-talento-v2 .candidate_availability_dropdown .options').toggle();

                // Show processing toast
                M.toast({ html: "Procesando..." });

                // Update dropdown text immediately (optimistic UI update)
                if (status == 'Actively searching') {
                    $('.menu-talento-v2 .candidate_availability_dropdown .dropdown').html('<span class="green_status"><i class="fas fa-circle"></i>Buscando Empleo</span>');
                }
                if (status == 'Open to hearing') {
                    $('.menu-talento-v2 .candidate_availability_dropdown .dropdown').html('<span class="orange_status"><i class="fas fa-circle"></i>Abierto a Escuchar</span>');
                }
                if (status == 'Not interested') {
                    $('.menu-talento-v2 .candidate_availability_dropdown .dropdown').html('<span class="red_status"><i class="fas fa-circle"></i>No Interesado</span>');
                }

                // Prepare API request
                var param = {
                    "site": "talento",
                    "msg": "talentCandidateAvailability"
                };
                var fields = {};
                fields['id'] = id;
                fields['availability'] = availability;
                param['fields'] = fields;

                // Build FormData
                var fd = new FormData();
                fd.append('param', JSON.stringify(param));

                // Send API request
                $.ajax({
                    type: 'POST',
                    url: base_url + '/api',
                    data: fd,
                    contentType: false,
                    processData: false,
                    dataType: 'json',
                    success: function(data) {
                        if (data.status == 1) {
                            M.toast({ html: "¡Actualizado exitosamente!" });
                        } else {
                            M.toast({ html: "Error al actualizar" });
                        }
                    },
                    error: function() {
                        if (typeof ErrorHandler !== 'undefined' && typeof ErrorHandler.reportException === 'function') {
                            ErrorHandler.reportException('Error de conexión al actualizar disponibilidad', {
                                context: 'candidate_menu_availability_update'
                            });
                        }
                        M.toast({ html: "Error de conexión" });
                    }
                });
            }
        }

        /**
         * Close dropdown when clicking outside
         */
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.candidate_availability_dropdown').length) {
                $('.menu-talento-v2 .candidate_availability_dropdown .options').hide();
            }
        });
    }
});
